import script from "./Rental.vue?vue&type=script&setup=true&lang=ts"
export * from "./Rental.vue?vue&type=script&setup=true&lang=ts"

import "./Rental.vue?vue&type=style&index=0&id=37c29b6c&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37c29b6c"]])

export default __exports__